import { delivery } from './config';
import { memo } from 'react';
import { declensionFactory } from '@helpers/declension';

const dayDelivery = declensionFactory('день', 'дня', 'дней');

interface TimeDeliveryPVZProps {
  regionId: number;
  className?: string;
}

export const TimeDeliveryPVZ = memo(function TimeDeliveryPVZ({ regionId, className }: TimeDeliveryPVZProps) {
  return (
    <div className={className}>
      Срок: {delivery[regionId]} {dayDelivery(delivery[regionId])}.
    </div>
  );
});
